<template>
    <div class="container">
        <div class="card pink darken-3">
          <div class="card-content white-text">
            <span class="card-title">Init with your 1RM</span>
            <p>
              Incredible {{ name }}, I am sure you know your 1RM back squat, deadlift, press or
              bench.
            </p>
          </div>
          <div class="card-action">
            <router-link :to="{name:'InitRecords'}">
              <i class="material-icons">flag</i> Go to Perf. recording
            </router-link>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'initRecordRemind',
  props: {
    'name': String
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cards/InitRecordRemind.vue